import React from 'react'
import createCompanyMutation from 'graphs/mutations/createCompany.graphql'
import companyValidation from 'validations/company'
import FormForRecord from 'components/FormForRecord'
import fields from 'fields/companies'

const RouteNew = ({ history: { goBack }, ...rest }) => (
  <FormForRecord
    mutation={createCompanyMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={fields}
    schema={companyValidation}
    title="Create A Company"
  />
)

export default RouteNew



// WEBPACK FOOTER //
// ./src/routes/admin/companies/new.js